import React, { Component } from 'react';
import { Link, withRouter } from 'react-router-dom';
import { compose } from 'recompose';
import { withAuthorization } from '../Session';
import { withFirebase } from '../Firebase';
import * as ROUTES from '../../constants/routes';
import * as ROLES from '../../constants/roles';
import { Form, Icon, Input, Card, Checkbox, Row , Col, Menu, Dropdown, Select, message, Button} from 'antd';
import { withLocalize } from "react-localize-redux";

const { Option } = Select;

const SignUpPage = () => (
  <>
    <Card>
      <h1>Administrera användare</h1>
    </Card>
    
    <SignUpForm />
  </>
)

const provinceData = ['Sverige', 'Finland'];
const cityData = {
  Sverige: ['Ale kommun','Alingsås kommun','Alvesta kommun','Aneby kommun','Arboga kommun','Arjeplogs kommun','Arvidsjaurs kommun','Arvika kommun','Askersunds kommun','Avesta kommun','Bengtsfors kommun','Bergs kommun','Bjurholms kommun','Bjuvs kommun','Bodens kommun','Bollebygds kommun','Bollnäs kommun','Borgholms kommun','Borlänge kommun','Borås stad','Botkyrka kommun','Boxholms kommun','Bromölla kommun','Bräcke kommun','Burlövs kommun','Båstads kommun','Dals-Eds kommun','Danderyds kommun','Degerfors kommun','Dorotea kommun','Eda kommun','Ekerö kommun','Eksjö kommun','Emmaboda kommun','Enköpings kommun','Eskilstuna kommun','Eslövs kommun','Essunga kommun','Fagersta kommun','Falkenbergs kommun','Falköpings kommun','Falu kommun','Filipstads kommun','Finspångs kommun','Flens kommun','Forshaga kommun','Färgelanda kommun','Gagnefs kommun','Gislaveds kommun','Gnesta kommun','Gnosjö kommun','Region Gotland','Grums kommun','Grästorps kommun','Gullspångs kommun','Gällivare kommun','Gävle kommun','Göteborgs stad','Götene kommun','Habo kommun','Hagfors kommun','Hallsbergs kommun','Hallstahammars kommun','Halmstads kommun','Hammarö kommun','Haninge kommun','Haparanda stad','Heby kommun','Hedemora kommun','Helsingborgs stad','Herrljunga kommun','Hjo kommun','Hofors kommun','Huddinge kommun','Hudiksvalls kommun','Hultsfreds kommun','Hylte kommun','Håbo kommun','Hällefors kommun','Härjedalens kommun','Härnösands kommun','Härryda kommun','Hässleholms kommun','Höganäs kommun','Högsby kommun','Hörby kommun','Höörs kommun','Jokkmokks kommun','Järfälla kommun','Jönköpings kommun','Kalix kommun','Kalmar kommun','Karlsborgs kommun','Karlshamns kommun','Karlskoga kommun','Karlskrona kommun','Karlstads kommun','Katrineholms kommun','Kils kommun','Kinda kommun','Kiruna kommun','Klippans kommun','Knivsta kommun','Kramfors kommun','Kristianstads kommun','Kristinehamns kommun','Krokoms kommun','Kumla kommun','Kungsbacka kommun','Kungsörs kommun','Kungälvs kommun','Kävlinge kommun','Köpings kommun','Laholms kommun','Landskrona stad','Laxå kommun','Lekebergs kommun','Leksands kommun','Lerums kommun','Lessebo kommun','Lidingö stad','Lidköpings kommun','Lilla Edets kommun','Lindesbergs kommun','Linköpings kommun','Ljungby kommun','Ljusdals kommun','Ljusnarsbergs kommun','Lomma kommun','Ludvika kommun','Luleå kommun','Lunds kommun','Lycksele kommun','Lysekils kommun','Malmö stad','Malung-Sälens kommun','Malå kommun','Mariestads kommun','Markaryds kommun','Marks kommun','Melleruds kommun','Mjölby kommun','Mora kommun','Motala kommun','Mullsjö kommun','Munkedals kommun','Munkfors kommun','Mölndals stad','Mönsterås kommun','Mörbylånga kommun','Nacka kommun','Nora kommun','Norbergs kommun','Nordanstigs kommun','Nordmalings kommun','Norrköpings kommun','Norrtälje kommun','Norsjö kommun','Nybro kommun','Nykvarns kommun','Nyköpings kommun','Nynäshamns kommun','Nässjö kommun','Ockelbo kommun','Olofströms kommun','Orsa kommun','Orust kommun','Osby kommun','Oskarshamns kommun','Ovanåkers kommun','Oxelösunds kommun','Pajala kommun','Partille kommun','Perstorps kommun','Piteå kommun','Ragunda kommun','Robertsfors kommun','Ronneby kommun','Rättviks kommun','Sala kommun','Salems kommun','Sandvikens kommun','Sigtuna kommun','Simrishamns kommun','Sjöbo kommun','Skara kommun','Skellefteå kommun','Skinnskattebergs kommun','Skurups kommun','Skövde kommun','Smedjebackens kommun','Sollefteå kommun','Sollentuna kommun','Solna stad','Sorsele kommun','Sotenäs kommun','Staffanstorps kommun','Stenungsunds kommun','Stockholms stad','Storfors kommun','Storumans kommun','Strängnäs kommun','Strömstads kommun','Strömsunds kommun','Sundbybergs stad','Sundsvalls kommun','Sunne kommun','Surahammars kommun','Svalövs kommun','Svedala kommun','Svenljunga kommun','Säffle kommun','Säters kommun','Sävsjö kommun','Söderhamns kommun','Söderköpings kommun','Södertälje kommun','Sölvesborgs kommun','Tanums kommun','Tibro kommun','Tidaholms kommun','Tierps kommun','Timrå kommun','Tingsryds kommun','Tjörns kommun','Tomelilla kommun','Torsby kommun','Torsås kommun','Tranemo kommun','Tranås kommun','Trelleborgs kommun','Trollhättans stad','Trosa kommun','Tyresö kommun','Täby kommun','Töreboda kommun','Uddevalla kommun','Ulricehamns kommun','Umeå kommun','UpplandsVäsby kommun','Upplands-Bro kommun','Uppsala kommun','Uppvidinge kommun','Vadstena kommun','Vaggeryds kommun','Valdemarsviks kommun','Vallentuna kommun','Vansbro kommun','Vara kommun','Varbergs kommun','Vaxholms stad','Vellinge kommun','Vetlanda kommun','Vilhelmina kommun','Vimmerby kommun','Vindelns kommun','Vingåkers kommun','Vårgårda kommun','Vänersborgs kommun','Vännäs kommun','Värmdö kommun','Värnamo kommun','Västerviks kommun','Västerås stad','Växjö kommun','Ydre kommun','Ystads kommun','Åmåls kommun','Ånge kommun','Åre kommun','Årjängs kommun','Åsele kommun','Åstorps kommun','Åtvidabergs kommun','Älmhults kommun','Älvdalens kommun','Älvkarleby kommun','Älvsbyns kommun','Ängelholms kommun','Öckerö kommun','Ödeshögs kommun','Örebro kommun','Örkelljunga kommun','Örnsköldsviks kommun','Östersunds kommun','Österåkers kommun','Östhammars kommun','Östra Göinge kommun','Överkalix kommun','Övertorneå kommun'],
  Finland: ['Nanjing', 'Suzhou', 'Zhenjiang'],
};

const INITIAL_STATE = {
  username: '',
  email: '',
  passwordOne: '',
  passwordTwo: '',
  isAdmin: false,
  isEnglish: false,
  error: null,
  cities: cityData[provinceData[0]],
  secondCity: cityData[provinceData[0]][0],
  country: '',
  county: ''
}

const ERROR_CODE_ACCOUNT_EXISTS = 'auth/email-already-in-use'
const ERROR_MSG_ACCOUNT_EXISTS = `Konto med email finns redan.`

function handleChange(value) {
  // console.log(`selected ${value}`);
}

function handleButtonClick(e) {
  message.info('Click on left button.')
  // console.log('click left button', e)
}

function handleMenuClick(e) {
  message.info('Click on menu item.')
  // console.log('click', e)
}



class SignUpFormBase extends Component {

  constructor(props) {
    super(props);

    // state = {
    //   cities: cityData[provinceData[0]],
    //   secondCity: cityData[provinceData[0]][0],
    // };

    this.state = { ...INITIAL_STATE };
  }

  handleProvinceChange = value => {

    // console.log("cityData[value]", cityData[value])

    this.setState({
      cities: cityData[value],
      secondCity: cityData[value][0],
    });
  };
  
  onSecondCityChange = value => {
    this.setState({
      secondCity: value,
    });
  };

  onSubmit = event => {
  
    const { username, email, passwordOne, isEnglish, isAdmin, cities, secondCity} = this.state
    const roles = {}

    if (isEnglish) {
      isEnglish = true
    }

    if (isAdmin) {
      roles[ROLES.ADMIN] = ROLES.ADMIN
    }


    this.props.firebase
      .doCreateUserWithEmailAndPassword(email, passwordOne)
      .then(authUser => {
        // Create a user in your Firebase realtime database
        this.props.firebase.user(authUser.user.uid).set({
          username,
          email,
          roles,
          isEnglish, 
          cities,
          secondCity
        })
      })
      .then(() => {
        return this.props.firebase.doSendEmailVerification();
      })
      .then(() => {
        this.setState({ ...INITIAL_STATE });
        this.setState({ reg: true });
        //this.props.history.push(ROUTES.SIGN_UP);
      })
      .catch(error => {
        if (error.code === ERROR_CODE_ACCOUNT_EXISTS) {
          error.message = ERROR_MSG_ACCOUNT_EXISTS;
        }

        this.setState({ error });
      });

    event.preventDefault();
  };

  onChange = event => {
    this.setState({ [event.target.name]: event.target.value });
  }

  onChangeCheckbox = event => {
    this.setState({ [event.target.name]: event.target.checked });
  }

  render() {

    const { cities } = this.state

    const {
      username,
      email,
      passwordOne,
      passwordTwo,
      isEnglish,
      isAdmin,
      error,
      country,
      county
    } = this.state;

    const isInvalid =
      passwordOne !== passwordTwo ||
      passwordOne === '' ||
      email === '' ||
      username === '';

  
    return (

      <Row>
        <Col span={12}>

          <Card>

          <p>
          Här kan du skapa konton åt de olika användare i kommunerna som frå tillgång till HSR Blastic
          </p>

          <Form onSubmit={this.onSubmit} className="login-form">
            
            <Form.Item>

              <Input  name="username" onChange={this.onChange}
                prefix={<Icon type="user" style={{ color: 'rgba(0,0,0,.25)' }} />}
                placeholder="Namn på kontot"
              />
            
            </Form.Item>

            <Form.Item>

              <Input  name="email" onChange={this.onChange}
                prefix={<Icon type="mail" style={{ color: 'rgba(0,0,0,.25)' }} />}
                placeholder="Email"
              />

              {/* <input
                name="email"
                value={email}
                onChange={this.onChange}
                type="text"
                placeholder="Email Address"
              /> */}
            </Form.Item>

            <Form.Item>

              <Input  name="passwordOne" onChange={this.onChange} type="password"
                prefix={<Icon type="user" style={{ color: 'rgba(0,0,0,.25)' }} />}
                placeholder="Lösenord"
              />

              {/* <input
                name="passwordOne"
                value={passwordOne}
                onChange={this.onChange}
                type="password"
                placeholder="Password"
              /> */}
            </Form.Item>

            <Form.Item>

            <Input  name="passwordTwo" onChange={this.onChange} type="password"
                prefix={<Icon type="user" style={{ color: 'rgba(0,0,0,.25)' }} />}
                placeholder="Bekräfat lösenord"
              />

            {/* <input
              name="passwordTwo"
              value={passwordTwo}
              onChange={this.onChange}
              type="password"
              placeholder="Confirm Password"
            /> */}
            </Form.Item>

            <Form.Item>
              Gränsnitt på engelska: <Checkbox onChange={this.onChangeCheckbox} checked={isEnglish} name="isEnglish"></Checkbox>
              {/* <input
                name="isAdmin"
                type="checkbox"
                checked={isAdmin}
                onChange={this.onChangeCheckbox}
              /> */}
            </Form.Item>
            
            <Form.Item>
              <Select
                defaultValue={provinceData[0]}
                style={{ width: 200 }}
                onChange={this.handleProvinceChange}
                name="cities"
              >
                {provinceData.map(province => (
                  <Option key={province}>{province}</Option>
                ))}
              </Select>
              <Select
                style={{ width: 300 }}
                value={this.state.secondCity}
                onChange={this.onSecondCityChange}
                name="secondCity"
              >
                {cities.map(city => (
                  <Option key={city}>{city}</Option>
                ))}
              </Select>
            </Form.Item>
            

            <Button htmlType="submit" type="primary" >
              Skapa kontot
            </Button>

            {error && <p>{error.message}</p>}
          </Form>
          
          </Card>

        </Col>
      </Row>
    )
  }
}

const condition = authUser => !!authUser;

const SignUpLink = () => (
  <p>
    Don't have an account? <Link to={ROUTES.SIGN_UP}>Sign Up</Link>
  </p>
);

const SignUpForm = withRouter(withFirebase(SignUpFormBase));


export { SignUpForm, SignUpLink };



export default compose(
  withLocalize,
  withFirebase,
  withAuthorization(condition)
)(SignUpPage);

